// counselor rating
export const COUNSELOR_RATING_FIND_REQUEST = "COUNSELOR_RATING_FIND_REQUEST";
export const COUNSELOR_RATING_FIND_SUCCESS = "COUNSELOR_RATING_FIND_SUCCESS";
export const COUNSELOR_RATING_FIND_ERR = "COUNSELOR_RATING_FIND_ERR";

// service rating
export const SERVICE_RATING_FIND_REQUEST = "SERVICE_RATING_FIND_REQUEST";
export const SERVICE_RATING_FIND_SUCCESS = "SERVICE_RATING_FIND_SUCCESS";
export const SERVICE_RATING_FIND_ERR = "SERVICE_RATING_FIND_ERR";
